import CircularLoader from './Loader';
import { Tooltip } from '@mui/material';

const EditableField = ({
  id,
  title,
  value,
  defaultValue = "Add Info",
  candidateValue,
  isActive,
  setIsActive,
  isLoading,
  formComponent,
  suffix = "",
  onClickOverride,
  icon = null,
  extraMenu = null,
  classname,
  professionalDetails,
  canEdit = true 
}) => {
  const displayValue =
    value === "" || value === " " || value === "N/A" || classname
      ? defaultValue
      : candidateValue === "N/A" || value !== " "
        ? value
        : candidateValue;

  const showForm = canEdit && isActive;

  const tooltipTitle = classname
    ? "Send for Review"
    : canEdit
      ? `Edit ${title}`
      : "View only";

  const handleClick = canEdit
    ? onClickOverride || (() => setIsActive((prev) => ({ ...prev, isActive: true })))
    : undefined;

  return (
    <div className="flex gap-4">
      {icon && <div className="text-green-600 text-lg w-auto ">{icon}</div>}
      <div>
        {!showForm ? (
          <>
            <Tooltip title={tooltipTitle} disableHoverListener={!canEdit}>
              <p
                className={`text-gray-600 text-base flex items-center font-bold text-2xl ${canEdit ? 'cursor-pointer' : 'cursor-default'}`}
                onClick={handleClick}
                aria-disabled={!canEdit}
              >
                <span className={`${
                  title === 'name'
                    ? 'text-red-600 font-bold text-2xl'
                    : professionalDetails
                      ? 'text-[#5bb039]'
                      : classname
                        ? `${classname} font-bold`
                        : `font-bold`
                }`}>
                  {isLoading ? <CircularLoader /> : `${displayValue}${suffix}`}
                </span>
              </p>
            </Tooltip>
            {canEdit && extraMenu}
          </>
        ) : (
          formComponent
        )}
      </div>
    </div>
  );
};

export default EditableField;
